
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, CartesianGrid } from 'recharts';

interface MarketData {
  name: string;
  profit: number;
}

interface MarketBarChartProps {
  data: MarketData[];
}

const MarketBarChart: React.FC<MarketBarChartProps> = ({ data }) => {
  if (!data || data.length === 0) return null;

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#2b3139" vertical={false} />
        <XAxis
          dataKey="name"
          stroke="#b1b5c0"
          fontSize={10}
          tickLine={false}
          axisLine={false}
          interval={0}
        />
        <YAxis
          stroke="#b1b5c0"
          fontSize={10}
          tickLine={false}
          axisLine={false}
          tickFormatter={(val) => `$${val}`}
        />
        <Tooltip
          cursor={{ fill: '#2b3139', opacity: 0.4 }}
          contentStyle={{
            backgroundColor: '#1e2329',
            border: '1px solid #474d57',
            borderRadius: '12px',
            color: '#eaecef'
          }}
          itemStyle={{ color: '#eaecef', fontWeight: 'bold' }}
          labelStyle={{ color: '#b1b5c0', marginBottom: '4px' }}
          formatter={(value: number) => [`$ ${value.toFixed(2)}`, 'Resultado']}
        />
        <Bar dataKey="profit" radius={[4, 4, 0, 0]} barSize={30}>
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.profit >= 0 ? '#00ff66' : '#f6465d'} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default MarketBarChart;
